import { Data } from '../signup-data/DATA';
import { getQueryParamKeyFromDataKey } from './getQueryParamKeyFromDataKey';
const dataQueryParams = Object.values(Data).reduce((result, dataKey) => {
  result[dataKey] = getQueryParamKeyFromDataKey(dataKey);
  return result;
}, {});
export const QUERY_PARAM = Object.assign({
  RESURRECTION_COUNT: 'res_c'
}, dataQueryParams);